import { baseApi } from "./baseApi";
import { createSelector } from "@reduxjs/toolkit";
import {
  CONCEPTS_SUFFIX,
  SELECT_SEARCH_CONCEPT_SETS_BY_CONDITION_LAB_DOMAIN_CONDITION,
} from "../../utils/constants";

const BASE_URL = "/v2/concept-sets";
const V1_BASE_URL = "/v1/concept-sets";

export const conceptsSetsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createConceptSet: builder.mutation({
      query: (payload) => {
        const formData = new FormData();
        formData.append("domain", payload.domain);
        formData.append("codeSystem", payload.codeSystem);
        formData.append("csvFile", payload.csvFile);

        return {
          url: BASE_URL,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["ConceptSet"],
    }),
    updateConceptSet: builder.mutation({
      query: ({ conceptSetId, payload }) => {
        const formData = new FormData();
        formData.append("csvFile", payload.csvFile);
        formData.append("domain", payload.domain);
        formData.append("codeSystem", payload.codeSystem);
        return {
          url: `${BASE_URL}/${conceptSetId}`,
          method: "PUT",
          body: formData,
        };
      },
      invalidatesTags: ["ConceptSet"],
    }),
    getConceptSets: builder.query({
      query: () => BASE_URL,
      providesTags: ["ConceptSet"],
    }),
    getConceptSet: builder.query({
      query: (conceptSetId) => `${BASE_URL}/${conceptSetId}`,
      providesTags: ["ConceptSet"],
    }),
    searchConceptSetsByCondition: builder.query({
      query: (condition) => {
        return {
          url: V1_BASE_URL,
          method: "POST",
          body: condition,
        };
      },
      providesTags: ["ConceptSet"],
    }),
  }),
});

export const selectGetAllConceptSetsData =
  conceptsSetsApi.endpoints.getConceptSets.select();

export const selectSystemDomainValues = createSelector(
  selectGetAllConceptSetsData,
  (getAllConceptSetsResult) => {
    const data = getAllConceptSetsResult?.data ?? [];
    return data.map((concept) => ({
      system: concept.system,
      conceptSetId: concept._id,
      domain: concept.name.replace(CONCEPTS_SUFFIX, ""),
    }));
  }
);

export const selectSearchConceptSetsByConditionData = (
  condition = SELECT_SEARCH_CONCEPT_SETS_BY_CONDITION_LAB_DOMAIN_CONDITION
) => conceptsSetsApi.endpoints.searchConceptSetsByCondition.select(condition);

export const selectConceptSetsLoincValues = createSelector(
  (state, condition) =>
    selectSearchConceptSetsByConditionData(condition)(state),
  (searchConceptSetsByConditionResult) => {
    const values = searchConceptSetsByConditionResult?.data?.[0]?.values ?? [];
    const data = values.map((v) => ({
      code: v.code,
      description: v.description,
    }));
    return {
      data,
    };
  }
);

export const {
  useCreateConceptSetMutation,
  useUpdateConceptSetMutation,
  useGetConceptSetsQuery,
  useSearchConceptSetsByConditionQuery,
  useLazySearchConceptSetsByConditionQuery,
  useLazyGetConceptSetQuery,
} = conceptsSetsApi;
